import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-invite-link-cell-renderer',
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: './invite-link-cell-renderer.component.html',
  styleUrl: './invite-link-cell-renderer.component.scss',
})
export class InviteLinkCellRendererComponent implements ICellRendererAngularComp {
  params: any;

  isElevateTeam: boolean = false;

  constructor(
    private _appService: AppService,
    private modalService: NgbModal,
  ) {
    if (this._appService.team.isElevateTeam) {
      this.isElevateTeam = true;
    }
  }

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  showInviteLinkModal($event: any, content: any) {
    $event.preventDefault();
    this.modalService.open(content, { centered: true, windowClass: 'modal650px' });
  }
  copyLink() {
    navigator.clipboard.writeText(this.params.data.inviteLink);
  }
}
